"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectWithWhatsApp = void 0;
var _commonFormFields = require("@ori/common-form-fields");
var _reactHookForm = require("react-hook-form");
var _jsxRuntime = require("react/jsx-runtime");
const ConnectWithWhatsApp = props => {
  const {
    isAvailable,
    label
  } = props;
  const {
    formState: {
      isSubmitting
    }
  } = (0, _reactHookForm.useFormContext)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
    ...props,
    name: "connectWithWhatsApp",
    isSubmitting: isSubmitting,
    isAvailable: isAvailable,
    label: label
  });
};
exports.ConnectWithWhatsApp = ConnectWithWhatsApp;
//# sourceMappingURL=ConnectWithWhatsApp.js.map